/**
 * @flow
 * @relayHash 1155b98159681e8d3a66fe5562b39275
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddWorkflowInput = {|
  name: string,
  isDefault?: ?boolean,
|};
export type AddWorkflowMutationVariables = {|
  input: AddWorkflowInput
|};
export type AddWorkflowMutationResponse = {|
  +addWorkflow: {|
    +workflowEdge: {|
      +cursor: string,
      +node: {|
        +id: string,
        +name: string,
        +isDefault: boolean,
      |},
    |}
  |}
|};
export type AddWorkflowMutation = {|
  variables: AddWorkflowMutationVariables,
  response: AddWorkflowMutationResponse,
|};
*/


/*
mutation AddWorkflowMutation(
  $input: AddWorkflowInput!
) {
  addWorkflow(input: $input) {
    workflowEdge {
      cursor
      node {
        id
        name
        isDefault
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddWorkflowInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addWorkflow",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddWorkflowPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "workflowEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "WorkflowEdge",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cursor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Workflow",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isDefault",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddWorkflowMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddWorkflowMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddWorkflowMutation",
    "id": null,
    "text": "mutation AddWorkflowMutation(\n  $input: AddWorkflowInput!\n) {\n  addWorkflow(input: $input) {\n    workflowEdge {\n      cursor\n      node {\n        id\n        name\n        isDefault\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '43e5857189c69c45ee106424470321c9';
module.exports = node;
